<div class="flex between-spacer">
  <h3 class="titulo">Cerrar Caja</h3>
  <button class="btn-volver" routerLink="/venta/opciones/menu">volver</button>
</div>
